import {
  Button,
  ButtonGroup,
  Row,
  Col,
  Input,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Modal,
} from "reactstrap";

export default function TransferNowModal({
  showTransferModal,
  setShowTransferModal,
  confirmTransferNow,
  setConfirmTransferNow,
  completeTransfer,
}) {
  return (
    <Modal
      isOpen={showTransferModal}
      fullscreen="sm"
      autoFocus={false}
      toggle={() => {
        setConfirmTransferNow(false);
        setShowTransferModal(false);
      }}
    >
      <ModalHeader>Confirm Transfer</ModalHeader>
      <ModalBody className="d-flex align-items-center">
        <Input
          type="checkbox"
          checked={confirmTransferNow}
          onChange={(e) => setConfirmTransferNow(e.target.checked)}
          style={{ minWidth: "1.2em" }}
          required
        />
        <div className="ms-2">
          <strong>
            I confirm that I will be transferring the payment to the related company on this agreement now.
          </strong>
        </div>
      </ModalBody>
      <ModalFooter>
        <Row className={"d-flex justify-content-end"}>
          <Col>
            <ButtonGroup className="float-end">
              <Button color="primary" onClick={completeTransfer} disabled={!confirmTransferNow}>
                Confirm
              </Button>
              <Button
                onClick={() => {
                  setConfirmTransferNow(false);
                  setShowTransferModal(false);
                }}
              >
                Close
              </Button>
            </ButtonGroup>
          </Col>
        </Row>
      </ModalFooter>
    </Modal>
  );
}
